import React from "react";

const Navbar = () => {
  return (
    <div className="navigation">
      <a href="/" className="navigation__logo__link">
        <img
          src="assets/images/logo.png"
          className="navigation__logo"
          alt="logo"
        />
      </a>
    </div>
  );
};

export default Navbar;
